export const refEncode = (ref) => {
  return window.btoa(encodeURIComponent(JSON.stringify(ref)))
}
export const refDecode = (ref) => {
  return JSON.parse(decodeURIComponent(window.atob(ref)))
}